import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

// const theme = createTheme({
//     palette: {
//         primary: {
//             main: blueGrey[900],
//         },
//         secondary: {
//             main: blueGrey[100],
//         },
//     },
//   });
const borderColor = "black";
const styles = StyleSheet.create({
  row1: {
    flexDirection: "row",
    width: "100%",
    borderBottomColor: "black",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    fontSize: 9,
    // fontStyle: 'bold',
  },
  row2: {
    flexDirection: "row",
    borderBottomColor: "black",
    width: "50%",
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    fontSize: 9,
    marginTop: 10,
    // fontStyle: 'bold',
  },
  row3: {
    flexDirection: "row",
    borderBottomColor: "black",
    width: "50%",
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    fontSize: 9,
    // fontStyle: 'bold',
  },
  row4: {
    flexDirection: "row",
    borderBottomColor: "black",
    width: "50%",
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    fontSize: 9,
    // fontStyle: 'bold',
  },
  Label: {
    width: "80%",
    paddingRight: 8,
    borderRightColor: borderColor,
    borderRightWidth: 0,
    backgroundColor: "#ffffffff",
    textAlign: "left",
  },
  noteRow: {
    flexDirection: "row",
    width: "100%",
    fontSize: 9,
    marginBottom: 6,
  },
  noteHeading: {
    fontSize: 9,
    fontWeight: "bold",
    marginRight: 3,
  },
  noteText: {
    fontSize: 9,
    flex: 1,
    textAlign: "left",
    lineHeight: 1.4,
  },
  description: {
    width: "25%",
    borderRightColor: borderColor,
    textAlign: "left",
  },
});
const Signature = ({ invoice, user }) => {
  const capitalizeName = (name = "") => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const displayName =
    invoice?.preffered_email === "salesLead"
      ? capitalizeName(invoice?.sales_lead_name)
      : capitalizeName(`${user?.first_name || ""} ${user?.last_name || ""}`);

  return (
    <>
      {invoice?.notes || invoice?.note ? (
        <View style={styles.noteRow}>
          <Text style={styles.noteHeading}>NOTES:</Text>
          <Text style={styles.noteText}>{invoice?.notes || invoice?.note}</Text>
        </View>
      ) : null}
      <View style={styles.row1}>
        <Text style={styles.Label}>
          By submitting this certification electronically, I confirm that I have
          reviewed the information provided and certify that: The goods and/or
          services listed have been received and/or performed following the
          applicable contract or purchase order. The amounts are accurate,
          reasonable, and eligible for payment. No duplicate request has been or
          will be made for these goods or services. I understand that my
          electronic approval is a binding acknowledgement of the validity of
          this invoice and authorization for payment processing.
        </Text>
        {/* <Text style={styles.total}>{invoice.Received_By}</Text> */}
      </View>
      <View style={styles.row2}>
        {/* <Text style={styles.Label}>Name: {displayName}</Text> */}
        <Text style={styles.Label}>
          Name:{" "}
          {invoice?.Order?.createdBy?.first_name ||
          invoice?.Order?.createdBy?.last_name
            ? capitalizeName(
                `${invoice?.Order?.createdBy?.first_name || ""} ${invoice?.Order?.createdBy?.last_name || ""}`.trim(),
              )
            : displayName}
        </Text>

        <Text style={styles.Label}>
          Date:{" "}
          {invoice?.createdAt
            ? moment(invoice.createdAt).format("YYYY.MM.DD")
            : moment().format("YYYY.MM.DD")}
        </Text>
        {/* <Text style={styles.total}>{invoice.Signature_Date}</Text> */}
      </View>
      <View style={styles.row3}>
        {/* <Text style={styles.Label}>Title: Customer Service Manager </Text> */}
        <Text style={styles.Label}>
          Email:{" "}
          {invoice?.Order?.createdBy?.email ||
            (invoice?.preffered_email === "salesLead"
              ? invoice?.sales_lead_email
              : user?.email)}
        </Text>
        {/* <Text style={styles.total}>{invoice.Signature}</Text> */}
      </View>
    </>
  );
};

export default Signature;
